import React, { useState, createContext } from "react";

export const ToastContext = createContext();

ToastContext.displayName = "ToastContext";

export const ToastProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <ToastContext.Provider
      value={{
        visible,
        setVisible,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};
